// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
// require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("material-design-iconic-font/dist/css/material-design-iconic-font.min.css")

import "bootstrap"
import "../stylesheets/application"

var jQuery = require('jquery')
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

var moment = require('moment')
global.moment = moment;
window.moment = moment;

import I18n from 'i18n-js';

import "./app.js"
import "./app.init.light-sidebar.js"
import "./app-style-switcher.js"

import "./vendor/perfect-scrollbar/perfect-scrollbar.jquery.min.js"
import "./vendor/sparkline/sparkline.js"
import "./vendor/datatables/dataTables.bootstrap4.min.js"
import "./vendor/datatables/dataTables.responsive.min.js"
import "./vendor/jquery-ui-datepicker/jquery-ui-datepicker.js"
import "./vendor/bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js"
import "./vendor/daterangepicker/daterangepicker.js"
import "./vendor/summernote/summernote-bs4.min.js"
import "./vendor/select2/select2.min.js"
import "pc-bootstrap4-datetimepicker"
import "./vendor/slick/slick.min.js"

// https://stevepolito.design/blog/create-a-nested-form-in-rails-from-scratch/
import "./nested-forms/addFields.js"
import "./nested-forms/removeFields.js"

import "./waves.js"
import "./sidebarmenu.js"
import "./custom.js"
import "./dashboard.js"
import "./user.js"
import "./event.js"
import "./general-image.js"
import "./bom.js"
import "./variant.js"
import "./inventory.js"
import "./promotions.js"
import "./nested_form.js"
import "./membership.js"
import "./resource.js"
import "./highlight_resource.js"
import "./event-organization.js"
import "./slotmachine.js"
import "./slotmachine.min.js"
import "./edit_position.js"
import "./abo_number_validation.js"
import "./lucky_draw.js"
import "./upgrade-ticket-items"
import "./success_profile.js"
import "./image-list.js"
import "./export_report.js"
import "./incentive_trip.js"
import "./tqg_incentive_trip.js"
import "./tqg_downline_qualification.js"
import "./validation_major_function_qualification.js"
import "./validate_date_range.js"
import "./membership-report.js"
import "chartkick/chart.js"
import "./initSortable.js"
import "./shared-social-media.js"
import "./update-stock.js"
import "./event-session.js"
import "./event-attendee-info.js"
import "./collection-session.js"
import "./custom_admin.js"
import "./malaysia_address.js"
import "./shipping_fee_form.js"
import "./pase-center.js"
import "./person_in_charges.js"
import "./edit-guest.js"
import "./ticket-and-meal-transfer.js"

// file upload to aws
import fileUpload from './fileUpload.js'
import fileUploadDashboard from './fileUploadDashboard.js'
import fileMultiUpload from './fileMultiUpload.js'
import fileUploadCropper from './fileUploadCropper.js'

// file upload to local
import fileUploadLocal from './fileUploadLocal.js'
import fileUploadDashboardLocal from './fileUploadDashboardLocal.js'
import fileMultiUploadLocal from './fileMultiUploadLocal.js'
import fileUploadCropperLocal from './fileUploadCropperLocal.js'

// listen on 'turbolinks:load' instead of 'DOMContentLoaded' if using Turbolinks
document.addEventListener('DOMContentLoaded', () => {
  var datepicker = $.fn.datepicker.noConflict();
  $.fn.bootstrapDP = datepicker;

  I18n.locale = $('body').data('locale');
  I18n.translations = $('body').data('translations');
  global.I18n = I18n;

  // FOR UPLOAD SINGLE IMAGE
  var rails_env = document.querySelector('div[data-env]').dataset.env
  document.querySelectorAll('.upload-file').forEach(fileInput => {
    if (rails_env == 'development') {
      fileUploadLocal(fileInput)
    } else {
      fileUpload(fileInput)
    }
  })

  document.querySelectorAll('.upload-uppy-dashbord').forEach(fileInput => {
    if (rails_env == 'development') {
      fileUploadDashboardLocal(fileInput)
    } else {
      fileUploadDashboard(fileInput)
    }
  })

  // FOR UPLOAD MULTIPLE IMAGES
  document.querySelectorAll('.upload-multi-file').forEach(fileInput => {
    if (rails_env == 'development') {
      fileMultiUploadLocal(fileInput)
    } else {
      fileMultiUpload(fileInput)
    }
  })

  // FOR UPLOAD CROPPER IMAGE
  document.querySelectorAll('.upload-file-cropper').forEach(fileInput => {
    if (rails_env == 'development') {
      fileUploadCropperLocal(fileInput)
    } else {
      fileUploadCropper(fileInput)
    }
  })
})

$(document).ready(function(){
  // FOR UPLOAD NESTED FORM IMAGES
  var rails_env = document.querySelector('div[data-env]').dataset.env
  if ($('#nested-upload-img').length > 0) {
    $('.add_fields').click(function(){
      document.querySelectorAll('.upload-file').forEach(fileInput => {
        if (rails_env == 'development') {
          callSingleFileUploadLocal(fileInput)
        } else {
          callSingleFileUpload(fileInput)
        }
      })
    });
  }
})
